/**
 * Нормализация строки для поиска вхождений
 *
 * @export
 * @param {string} str Строка для нормализации
 * @returns {string} Нормализованная строка
 */
export const normalize = (str: string): string => {
  return (typeof str.normalize === 'function' ? str.normalize() : str)
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/й/g, 'и');
};

/**
 * Возвращает начальный индекс вхождения строки для поиска в исходной строке
 *
 * @export
 * @param {string} str Исходная строка
 * @param {string} searchStr Строка для поиска
 * @returns {string} Начальный индекс вхождения
 */
export const indexOf = (str: string, searchStr: string, position?: number | undefined) => {
  return normalize(str).indexOf(normalize(searchStr), position);
};
